import React, { Component } from 'react';
import { DbLogoText } from '../../../components/common/icons';
import { Office, Email } from '@dbk/ui-icons';
import Dropdown from '@dbk/ui-dropdowns';
import { PALETTE, REGION, KEY_CODE } from '../../../constants';
import languageData from '../../../data/language-list.json';
import { createContainer } from '@dbk-legacy/muster/react';
import { find } from 'lodash';
import Text from '@dbk/ui-text';
import { View } from '@dbk/ui-react-utils';

import './login.css';
import DbText from '../../../assets/svgs/db-text';
class Header extends Component {

    constructor(props) {
        super(props);
      }

    state = {
        hoveredElement: null,
      }

    convertToDropDown = values => {
        if (values && values.length) {
            if (values.length >= 1) {
                return values.map(e => ({
                    label: e.language,
                    value: e.key,
                    code: e.langCode
                }));
            }

            return values.map(e => ({
                value: e.key,
                code: e.langCode
            }));
        }
        return [];
    }

    pressedConfirm = key => {
        const languageObj = find(languageData.languageList, { key })
        const {
            languages: { destLanguageCode, saveLanguageAtLogin }

        } = this.props;
        if(languageObj.langCode === "de-CH"){
            document.documentElement.setAttribute('lang', "de");
        }else{
            document.documentElement.setAttribute('lang', languageObj.langCode);
        }
        
        const destLang = destLanguageCode.includes(key.toLowerCase());
        if (!destLang) {
            saveLanguageAtLogin({ languageObj });
        }
    };

    handleFaq = (e) => {
        if((e && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
            this.props.changePage('/login-faq');
        }
    };

    handleContactUs = (e) => {
        if((e && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
            this.props.changePage('/login-contact-us');
        }
    };

    handleMouseEnter=(element)=>{
        this.setState({hoveredElement:element});
        };
      
    handleMouseLeave=()=>{
        this.setState({hoveredElement:null});
    }

    render = () => {

        let languageListArray = [];
        const { i18n: { messages }, languages: { destLanguage }, app, config: { regionCode } } = this.props;

        languageListArray = languageData.languageList && this.convertToDropDown(languageData.languageList)
        const languageCH = destLanguage === "English" ? "English" : "Deustche";
        const languageAPAC = destLanguage === "English" ? "ZH" : "default";
        const languageSelected = regionCode === 'CH' ? languageCH : languageAPAC;

        return (
            <View className='login login-header'>
                <View>
                    <DbText className="login__logo" />
                </View>
                <View className='login-header-content'>
                    <View className='cursor-pointer display-flex-row faq-title-container margin-right-40' aria-label={messages['app.login.accessibility.link.contactUs']} role='button' tabIndex={0} onKeyDown={(e) => this.handleContactUs(e)} onClick={() => this.handleContactUs()} onMouseEnter={()=> this.handleMouseEnter("contact-us")} onMouseLeave={()=>this.handleMouseLeave()}>
                        <Email height={32} width={32} color={this.state.hoveredElement === "contact-us" ? PALETTE.touchableOpacityEnable : PALETTE.secondaryActive} className='margin-right-10'></Email>
                        <Text size ="big" className={`${this.state.hoveredElement === "contact-us" ? "textHoverColor cursor-pointer" : "cursor-pointer"}`}  >{messages['app.login.contact.us']}</Text>
                    </View>
                    <View className='cursor-pointer display-flex-row faq-title-container margin-right-40' aria-label={messages['app.login.faq']} role='button' tabIndex={0} onKeyDown={(e) => this.handleFaq(e)} onClick={() => this.handleFaq()} onMouseEnter={()=> this.handleMouseEnter("faq")} onMouseLeave={()=>this.handleMouseLeave()}>
                        <Office height={32} width={32} color={this.state.hoveredElement === "faq" ? PALETTE.touchableOpacityEnable : PALETTE.secondaryActive} className='margin-right-10'></Office>
                        <Text size ="big" className={`${this.state.hoveredElement === "faq" ? "textHoverColor cursor-pointer" : "cursor-pointer"}`}>{messages['app.login.faq']}</Text>
                    </View>
                    <View role="list" className="margin-right-40" >
                        <Dropdown
                            defaultLabel={false}
                            fullWidth
                            className='dropdown-custom-width'
                            tetherProps={{
                                constraints: [{
                                    to: 'window',
                                    attachment: 'together',
                                }],
                                classPrefix: 'dropdown-custom-width'
                                }}
                            name="languageSeletcor"
                            title="language selector"
                            tabIndex={0}
                            selected={languageSelected}
                            options={languageListArray}
                            size='large'
                            onChange={option => {
                                this.pressedConfirm(option)
                            }}
                        />
                    </View>
                </View>
            </View>
        );
    }

}
export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        languages: {
            saveLanguageAtLogin: { $call: 'saveLanguageAtLogin' },
            getlanguages: { $call: 'getlanguages' },
            destLanguage: true,
            destLanguageCode: true,
        },
        config: {
            regionCode: true
        },
        changePage: { $call: 'ui.history.push' },
    },
})(Header);



